
import React      from 'react';
import CSSModules from 'react-css-modules';

import _ from 'lodash';

import classNames   from 'classnames/bind';
import stylingUtils from '../../services/stylingUtilities';

import style from './style.scss';

class InlineError extends React.Component {

    _getInputClassName() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'error-list': true
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    _getErrors() {

        if (this.props.errors.errorContainer) {

            if (Array.isArray(this.props.errors.errorContainer)) {

                return (
                    this.props.errors.errorContainer.map((errorMessage, index) => {

                        return (
                            <li key={ index } styleName="error">
                                { errorMessage }
                            </li>
                        )
                    })
                )

            } else {

                return (
                    <li styleName="error">
                        { this.props.errors }
                    </li>
                )
            }

        } else {

            if (Array.isArray(this.props.errors)) {

                return (
                    this.props.errors.map((errorMessage, index) => {

                        return (
                            <li key={ index } styleName="error">
                                { errorMessage }
                            </li>
                        )
                    })
                )

            } else {

                return (
                    <li styleName="error">
                        { this.props.errors }
                    </li>
                )
            }
        }
    }

    render() {

        if (this.props.errors) {

            return (
                <ul className={ this._getInputClassName() }>
                    { this._getErrors() }
                </ul>
            );
        }
    }
}

export default CSSModules(InlineError, style);


// WEBPACK FOOTER //
// ./components/InlineError/index.js